module.exports = __webpack_public_path__ + "static/media/etax-logo-en.f0771feb.png";